import React from "react";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const bull = (
    <Box
      component="span"
      sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
      •
    </Box>
  );

const CartTest = () => {
    return (
        <Box>
            Cart project
        </Box>
    )
}

export default CartTest;
